import { Link } from "react-router-dom";
import { JawaMark } from "@/components/Logo";

export default function PaymentCancel() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-jawa-ivory px-6" data-testid="payment-cancel-page">
      <div className="w-full max-w-md border border-jawa-stone bg-white p-10 text-center shadow-sm">
        <JawaMark className="mx-auto h-12 w-12 text-jawa-espresso" />
        <h1 className="mt-6 font-serif text-3xl font-medium text-jawa-espresso">No charge made.</h1>
        <p className="mt-3 text-sm leading-relaxed text-jawa-espresso/60">
          Your checkout was cancelled. The guides will be waiting whenever you are ready.
        </p>
        <Link
          to="/#guides"
          data-testid="payment-cancel-guides-link"
          className="mt-8 inline-block bg-jawa-espresso px-8 py-4 text-xs font-semibold uppercase tracking-[0.25em] text-jawa-ivory transition-colors hover:bg-jawa-terracotta"
        >
          Back to the Guides
        </Link>
      </div>
    </div>
  );
}
